import setupEditor from '../../editor/setupEditor.js';

export default function initEditor() {
  const holder = document.querySelector('.codex-editor-wrapper');
  if (!holder) return;

  const textarea = document.querySelector('.codex-editor-textarea');
  const data = JSON.parse(textarea.value);

  async function onChange() {
    const content = await editor.save();
    textarea.value = JSON.stringify(content);
  }

  const editor = setupEditor({ holder, data, onChange });
}
